import { getToken } from '@scouts/auth'

export const getAccessToken = () => {
    return getToken()
}
